import baseApi, {
    transformResponseFromData,
    // transformResponseFromMessage,
    provideTags,
    provideTag,
} from 'store/slices/api/baseApi'
import {constructUrl, transformClientsResponse} from './utils'

const clientsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getClients: build.query({
            query: () => ({url: 'Planner/getPlannerClients', method: 'GET'}),
            transformResponse: transformClientsResponse,
            providesTags: (result) =>
                provideTags('Client', result, 'PlannerClientKey'),
        }),
        getClient: build.query({
            query: ({ClientAccountKey}) => ({
                url: `Planner/getPlannerClient/${ClientAccountKey}`,
                method: 'GET',
            }),
            transformResponse: transformResponseFromData,
            providesTags: (result) =>
                provideTag('Client', result, 'PlannerClientKey'),
        }),
        createClient: build.mutation({
            query: (client) => {
                console.log('create client', client)
                return {
                    url: 'Planner/postPlannerClients',
                    method: 'POST',
                    body: client,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTags('Client'),
        }),
        saveClient: build.mutation({
            query: (client) => {
                console.log('save client mutation req', client)
                return {
                    url: 'Planner/putPlannerClients',
                    method: 'PUT',
                    body: client,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) =>
                provideTag('Client', result, 'PlannerClientKey'),
        }),
        deleteClient: build.mutation({
            query: (body) => {
                console.log('delete client mutation req', body)
                return {
                    url: 'Planner/deletePlannerClients',
                    method: 'DELETE',
                    body: body,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('Client'),
        }),
        generateClientLink: build.mutation({
            query: ({PlannerClientKey, sendSms = true}) => {
                return {
                    url: `Planner/generateClientUrl?plannerClientKey=${PlannerClientKey}&sendSms=${sendSms}`,
                    method: 'POST',
                    body: {},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Client', result),
        }),
        getPlannerClientRequest: build.query({
            query: ({request}) => {
                console.log('get client req', {
                    request,
                })
                return {
                    url: `Planner/getPlannerClientRequest?request=${request}`,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('Client'),
        }),
        getClientRequests: build.query({
            query: (plannerClientKey) => {
                console.log('getClientRequests', {
                    plannerClientKey,
                })
                return {
                    url: `Planner/getClientRequests?plannerClientKey=${plannerClientKey}`,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Client', result),
        }),
        getPlannerActivities: build.query({
            query: ({from, to}) => {
                console.log('getPlannerActivities period', {
                    from,
                    to,
                })
                const url = constructUrl('Planner/getPlannerActivities', {
                    dateFrom: from,
                    dateTo: to,
                })
                return {
                    // url: `Planner/getPlannerActivities?activitiesFrom=${from}?activitiesTo=${to}`,
                    url,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Client', result),
        }),
        getPlannerClientPdfs: build.query({
            query: ({pdfUrl}) => {
                console.log('getPlannerClientPdfs', {
                    pdfUrl,
                })
                return {
                    url: `Planner/getPlannerClientPdfs?url=${pdfUrl}`,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Client', result),
        }),
    }),
    overrideExisting: false,
})

export default clientsApi

export const {
    useGetClientQuery,
    useGetClientsQuery,
    useGetPlannerClientRequestQuery,
    useCreateClientMutation,
    useSaveClientMutation,
    useDeleteClientMutation,
    useGenerateClientLinkMutation,
    useGetClientRequestsQuery,
    useGetPlannerActivitiesQuery,
    useGetPlannerClientPdfsQuery,
} = clientsApi
